import { useCrmData } from '../../../contexts/CrmProviders';
import { hasBillableStripeSubscription } from '../../../domain/entities/Subscription';
import { useSubscriptionData } from './useSubscriptionData';
import { useSubscriptionStatus } from './useSubscriptionStatus';
import { useSubscriptionActions } from './useSubscriptionActions';

// Re-exportar tipos dos sub-hooks
export type { UsageLimits } from './useSubscriptionData';
export type { SubscriptionStatusInfo } from './useSubscriptionStatus';

// =============================================================================
// HOOK PRINCIPAL (FACADE)
// =============================================================================

export const useSubscription = () => {
    // Dados legados (compatibilidade com sistema antigo)
    const {
        subscriptionPlans: legacyPlans,
        subscription: legacySubscription,
        isLoading: legacyLoading,
    } = useCrmData();

    // Sub-hooks especializados
    const {
        stripeSubscription,
        stripePlans,
        limits,
        isLoading: stripeLoading,
        refreshData,
    } = useSubscriptionData();

    const statusInfo = useSubscriptionStatus(stripeSubscription);

    const actions = useSubscriptionActions(stripePlans, legacyPlans);

    // Trial local (sem stripe_subscription_id) ainda precisa de Checkout
    const hasPaidSubscription = hasBillableStripeSubscription(stripeSubscription);

    // =================================================================
    // RETORNO UNIFICADO
    // =================================================================

    return {
        // Dados legados (compatibilidade)
        plans: legacyPlans,
        subscription: legacySubscription,
        isLoading: legacyLoading || stripeLoading,

        // Novos dados Stripe
        stripeSubscription,
        stripePlans,
        limits,

        // Status derivados
        isBlocked: statusInfo.isBlocked,
        trialDaysLeft: statusInfo.trialDaysLeft,
        subscriptionStatusText: statusInfo.statusText,
        canUpgrade: statusInfo.canUpgrade,
        isPastDue: statusInfo.isPastDue,
        isTrialing: statusInfo.isTrialing,
        isActive: statusInfo.isActive,
        hasPaidSubscription,

        // Estado UI
        billingCycle: actions.billingCycle,
        isSelectionModalOpen: actions.isSelectionModalOpen,
        planToConfigure: actions.planToConfigure,
        isCheckoutLoading: actions.isCheckoutLoading,

        // Handlers
        handleToggle: actions.handleToggle,
        handleSelectPlan: actions.handleSelectPlan,
        handleConfirmSubscription: actions.handleConfirmSubscription,
        closeSelectionModal: actions.closeSelectionModal,
        navigateToBilling: actions.navigateToBilling,
        refreshSubscription: refreshData,
    };
};
